import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';

export default function GridContainerWrapper({ children }) {
	return (
		<Grid
			container
			pt={8}
			pb={4}
			px={{ xs: 0, md: 4 }}
			m={{ xs: '0rem', sm: '0 auto' }}
			maxWidth={{ xs: '100%', sm: '551px' }}
			spacing={3.25}
		>
			{children}
		</Grid>
	);
}
GridContainerWrapper.propTypes = {
	children: PropTypes.node.isRequired,
};
